import { Typography } from '@persona-id/design-tokens';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import { TableNullState } from 'dashboard/layouts/TableLayout';
import Button from 'design-system/components/Button';
import IconPlus from 'images/icons/plus.svg';

const NullStateContainer = styled('div')`
  margin-top: ${SPACINGS.base * 10}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NullStateHeaderText = styled('p')`
  ${Typography.HeadingMedium};
  margin-bottom: ${SPACINGS.base}px;
`;

const NullStateBodyText = styled('p')`
  margin-bottom: ${SPACINGS.base * 4}px;
`;

interface ButtonTableNullStateProps {
  active: boolean;
  dataTestBlock: string;
  activeText: string;
  inactiveText: string;
  headerText: string;
  buttonEnabled?: boolean;
  handleButtonClick: () => void;
}

const ButtonTableNullState = ({
  dataTestBlock,
  active,
  activeText,
  inactiveText,
  headerText,
  buttonEnabled = true,
  handleButtonClick,
}: ButtonTableNullStateProps) => {
  return (
    <TableNullState dataTestBlock={dataTestBlock}>
      <NullStateContainer>
        <NullStateHeaderText>{headerText}</NullStateHeaderText>
        {active ? (
          <>
            <NullStateBodyText>{activeText}</NullStateBodyText>
            <Button
              width='auto'
              data-test={`${dataTestBlock}-null-state__button`}
              disabled={!buttonEnabled}
              onClick={handleButtonClick}
              prefixIcon={<IconPlus />}
            >
              Add item
            </Button>
          </>
        ) : (
          <NullStateBodyText>{inactiveText}</NullStateBodyText>
        )}
      </NullStateContainer>
    </TableNullState>
  );
};

export default ButtonTableNullState;
